function init_(context) {
  const heroVideo = context.querySelector('.hero-video');
  if(heroVideo != null){
    const accordionHeader = document.querySelectorAll(".accordion-header");
    /* const heroIntro = heroVideo.querySelector('.hero-video__intro');
    const videoEmbedFieldLazymodal = heroVideo.querySelector(".field--name-field-media-video");
    const play = heroVideo.querySelector('.video-embed-field-lazy-play'); */

    const heroVideoFinishIntro = heroVideo.querySelector('.hero-video-finish-intro');
    const slider = context.querySelector('.block-field-blocknodeproduct-landingfield-slide');

    for (let index = 0; index < accordionHeader.length; index++) {
      const element = accordionHeader[index];
      element.children[0].classList.add("collapsed");
    }

    setTimeout(() => {
      let modalEmbedVideo = context.querySelector('#modal-embed-video')
      if (modalEmbedVideo) {
        let btnClose = modalEmbedVideo.querySelector(".close");
        console.log(btnClose);
        btnClose.setAttribute("data-bs-dismiss", "modal");
      }
    }, 1000);

    //play.classList.add('hidden');
    let btnShowIntro = context.createElement("div");
    btnShowIntro.innerHTML = "play";
    btnShowIntro.classList.add("btn__box--intro");

    //videoEmbedFieldLazymodal.appendChild(btnShowIntro);
    btnShowIntro.addEventListener("click", function (e) {
      //heroIntro.classList.add('show-intro');
    });
    heroVideoFinishIntro.addEventListener("click", function (e) {
      /*  heroIntro.classList.remove('show-intro');
      play.classList.remove('hidden');
      btnShowIntro.classList.add('hidden'); */
    });

    if (slider) {
      idAncla = "hero-video";
      context.querySelector(".hero-video").id = idAncla;
      let btnAncla = context.createElement("a");
      btnAncla.innerHTML = "play";
      btnAncla.classList.add("btn__club--ancla");
      btnAncla.href = "#hero-video";
      slider.appendChild(btnAncla);
      btnAncla.addEventListener("click", clickHandler);
      function clickHandler(e) {
        e.preventDefault();
        const href = this.getAttribute("href");
        const offsetTop = document.querySelector(href).offsetTop;

        scroll({
          top: offsetTop,
          behavior: "smooth"
        });
      }
    }
  }
}
Drupal.behaviors.NodeProductLanding = {
  attach: (context) => {    
    if (context.querySelector(".node--type-product-landing") && document.body.classList.contains('page-moments-multiplayer') != true) {
      window.addEventListener("load", init_(context));
    }
  }
}
